import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";
import { Workbook } from "exceljs";
/**
 *
 * @param {any[]} sellsByDay
 * @returns {Workbook}
 */
export const exportExcel = async (
  sellsByDay,
  selectedStore,
  selectedYear,
  selectedMonth
) => {
  const json = excelHelper.jsonToJson(
    [sellsByDay],
    [
      {
        name: "VENTAS DIA - MES",
        props: [
          {
            inValue: "day",
            outValue: "DIA",
          },
          {
            inValue: "total",
            outValue: "VENTAS TOTALES",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName(selectedStore, selectedYear, selectedMonth);
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = (selectedStore, selectedYear, selectedMonth) => {
  const storeName = selectedStore.label;
  return selectedStore.value == 0
    ? formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-general-ventas-por-dia_" +
        selectedYear +
        "_" +
        selectedMonth +
        ".xlsx"
    : formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-ventas-por-dia_" +
        selectedYear +
        "_" +
        selectedMonth +
        "_" +
        storeName.toLowerCase() +
        ".xlsx";
};



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CardSellsByDay/excel.js